import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Video } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ParagraphActions } from '../paragraph/paragraph.actions';
import { flatten } from '@lyceo/shared/util';
import { mapVideo } from './video.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const VIDEO_FEATURE_KEY: string = 'video';

// eslint-disable-next-line
export interface VideoState extends EntityState<Video> {}

function sortByPosition(a: Video, b: Video): number {
  return a.position - b.position;
}

export const videoAdapter: EntityAdapter<Video> = createEntityAdapter<Video>({
  sortComparer: sortByPosition,
});

export const initialVideoState: VideoState = videoAdapter.getInitialState({});

const reducer: ActionReducer<VideoState, Action> = createReducer(
  initialVideoState,
  on(AuthActions.logoutSuccess, (): VideoState => initialVideoState),
  on(
    ParagraphActions.getParagraphByIdsSuccess,
    (state, action): VideoState =>
      videoAdapter.upsertMany(
        flatten(
          action.paragraphs.map((paragraphDto) =>
            paragraphDto.videos.map((videoDto) => mapVideo(videoDto)),
          ),
        ),
        {
          ...state,
        },
      ),
  ),
  on(
    ParagraphActions.getParagraphByIdSuccess,
    (state, action): VideoState =>
      videoAdapter.upsertMany(
        action.paragraph.videos.map((videoDto) => mapVideo(videoDto)),
        {
          ...state,
        },
      ),
  ),
);

export function videoReducer(
  state: VideoState | undefined,
  action: Action,
): VideoState {
  return reducer(state, action);
}
